<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="所属校区" prop="courseId">
              <el-cascader style="width:100%" :show-all-levels="false" ref="tree" @change="subjectChange" :options="subjectTreeList" :props="subjectTreeProps" collapse-tags clearable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="人员" prop="state">
              <el-input clearable v-model="searchForm.userName" placeholder="请输入" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="6" style="float:right">
            <el-button-group style="float:right">
              <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
              <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-table ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%;" v-loading="Loading" border @selection-change="selectionChange" rowClassName="table-list">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column show-overflow-tooltip width="60" label="排行">
          <template slot-scope="scope">
            <span>{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="area" label="所属校区"></el-table-column>
        <el-table-column show-overflow-tooltip prop="userName" label="老师"></el-table-column>
        <el-table-column show-overflow-tooltip prop="questionAnsweringNum" label="回复个数"></el-table-column>
        <el-table-column show-overflow-tooltip prop="count" label="点赞数"></el-table-column>
        <el-table-column show-overflow-tooltip prop="time" label="平均回复时间"></el-table-column>

      </el-table>
      <el-pagination v-if="!Loading" background :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px;text-align: right;" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" width="50%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules"></el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addQuestionQuery">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" width="50%" left>
      <el-form ref="editForm" :model="editForm" :label-width="formLabelWidth" :rules="editFormRules"></el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateQuestionQuery">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.path == "/quizDetail") {
        vm.pageList();
      }
    });
  },

  data () {
    return {

      stateList: [
        {
          label: "录播",
          value: "0"
        },
        {
          label: "直播",
          value: "1"
        },
        {
          label: "面授",
          value: "2"
        },
        {
          label: "题库",
          value: "3"
        },
        // {
        //   label: "已取消",
        //   value: "-1"
        // }
      ],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true
      },
      addFormVisible: false,
      editFormVisible: false,
      Loading: false,
      searchForm: {
        unsolved: '',
        courseIdList: [],
        questionsContent: '',
        questionTimePeriod: null,
        answerTimePeriod: null,
      },
      addForm: {},
      addFormRules: {},
      editForm: {},
      editFormRules: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/questionQuery/upload`,
      fileList: [],
      loading: false,
      activeName: 'first'
    };
  },
  methods: {
    handleClick () { },
    getSubjectTreeList () {
      this.api.dictionary.getCampusTreeList({ parentId: 1 }).then(result => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              if (items.children.length != 0) {
                for (let itemss of items.children) {
                  delete itemss.children;
                }
              } else {
                // delete items.children;
              }
            }
          } else {
            // delete item.children;
          }
        }
        this.subjectTreeList = result.data;
      })
    },
    subjectChange (val) {
      this.searchForm.area = [];
      val.forEach(item => {
        this.searchForm.area.push(item[2]);
      });
      console.log(this.searchForm.area);
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getQuestionQuery () {
      this.api.questionQuery
        .getQuestionQuery({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatSeconds (value) {
      let result = parseInt(value)
      let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
      let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
      let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

      let res = '';
      if (h !== '00') res += `${h}h`;
      if (m !== '00') res += `${m}min`;
      res += `${s}s`;
      return res;
    },
    pageList () {
      this.Loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.api.questionQuery.quizRankList(this.searchForm).then(result => {
        console.log(result);
        result.data.records.forEach(v => {
          v.avgAnswerTime = this.formatSeconds(v.avgAnswerTime)
        })
        this.page.rows = result.data.records;
        this.page.total = result.data.total;
        this.Loading = false;
      }).catch(error => {
        console.log(error);
      });
    },
    addQuestionQuery () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.questionQuery
            .addQuestionQuery(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateQuestionQuery () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.questionQuery
            .updateQuestionQuery(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteQuestionQuery (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.questionQuery
            .deleteQuestionQuery([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    goDetial (row) {
      this.$router.push({
        path: "/quizDetail",
        query: {
          id: row.id,
          type: row.type,
          unsolved: row.unsolved,
        }
      })
    },
    batchDeleteQuestionQuery () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.questionQuery
            .deleteQuestionQuery(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.$refs.searchForm.resetFields();
      let obj = {};
      try {
        this.$refs.tree.clearValue(obj);
      } catch (err) {
        this.$refs.tree.handleClear(obj);
      }
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    }
  },
  computed: {
    reqData () {
      return this.$store.state.user;
    }
  },
  watch: {

    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {

      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getQuestionQuery();
      }
    }
  },
  mounted () {
    this.getSubjectTreeList();
    this.pageList();
  }
};
</script>

<style lang="less" scoped>
.state {
  text-align: center;
  span {
    padding: 4px 8px;
    color: #fff;
    border-radius: 4px;
    margin-right: 10px;
  }
}
</style>
<style lang="less">
.table-list {
  td {
    img {
      width: 50px;
      height: 50px;
    }
  }
  .mainColor img {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/question/quizRank.vue